/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILanguages, IReason } from "../../../types/ILanguages";
const initialState = {
  loading: false,
  errorMessage: null,
  languages: [] as Array<ILanguages>,
  reasons: [] as Array<IReason>,
  defaultLanguage: null as unknown as { code: string; name: string },
};

const settingAccountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    getLanguagesStart(state) {
      state.loading = true;
    },
    getLanguagesSuccess(state, action: PayloadAction<Array<ILanguages>>) {
      state.loading = false;
      state.languages = action.payload;
    },
    getLanguagesFailed(state) {
      state.loading = false;
    },
    setLanguageDefaultStart(state) {
      state.loading = true;
    },
    setLanguageDefaultSuccess(state) {
      state.loading = false;
    },
    setLanguageDefaultFailed(state) {
      state.loading = false;
    },
    getReasonsStart(state) {
      state.loading = true;
    },
    getReasonsSuccess(state, action) {
      state.loading = false;
      state.reasons = action.payload;
    },
    getReasonsFailed(state, action) {
      state.loading = false;
      state.reasons = [];
      state.errorMessage = action.payload;
    },
    getDefaultLanguageSettingStart(state) {
      state.loading = true;
    },
    getDefaultLanguageSettingSuccess(
      state,
      action: PayloadAction<{ code: string; name: string }>
    ) {
      state.defaultLanguage = action.payload;
    },
    getDefaultLanguageSettingFailed(state) {
      state.loading = false;
    },
  },
});

export const AccountAction = settingAccountSlice.actions;

export default settingAccountSlice.reducer;
